import React, { useState } from "react";
import { FaTimesCircle } from "react-icons/fa";
import translations from "../../translation"; // Import translations

const Rejected = ({ content, language }) => {
  const [showPopup, setShowPopup] = useState(false);

  // Function to translate static text
  const translate = (key) => translations[language][key] || key;

  return (
    <>
      {/* Main Card */}
      <div
        className="bg-white shadow-lg rounded-lg overflow-hidden transform transition-transform duration-300 hover:scale-105 p-6 cursor-pointer"
        onClick={() => setShowPopup(true)}
      >
        <div className="flex items-center mb-4">
          <div className="cross flex-shrink-0">
            <FaTimesCircle className="text-5xl" />
          </div>
          <div className="ml-6">
            {/* Translated title */}
            <h3 className="text-xl font-bold">{translate("rejectedTitle")}</h3>
          </div>
        </div>
        <p className="text-gray-600 mb-4">
          {/* Dynamic content remains unchanged */}
          {content} {translate("rejectedMessage")}
        </p>
        <p className="text-sm font-medium text-gray-700">
          <span className="text-gray-500">{translate("statusLabel")}: </span>
          {translate("statusRejected")}
        </p>
      </div>

      {/* Popup Modal */}
      {showPopup && (
        <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg p-6 max-w-lg w-full">
            <h3 className="text-xl font-bold mb-4">{translate("rejectedTitle")}</h3>
            <p className="text-gray-600 mb-4">
              {translate("statusLabel")}: {translate("statusRejected")}
            </p>
            <p className="text-gray-700">
              {content} {translate("rejectedPopupMessage")}.
            </p>
            <button
              className="text-white mt-4 px-4 py-2 bg-red-500 rounded-lg hover:bg-red-400"
              onClick={() => setShowPopup(false)}
            >
              {translate("closeButton")}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Rejected;
